(ns web3.components.dropify
  ;; separate these deps for code-splitting purposes
  (:require ["jquery" :as -jquery]
            ["dropify" :as -dropify]))

(def ^js jquery -jquery)
(def ^js dropify -dropify)

